import React, { useState } from 'react';
import { useForm } from '../context/FormContext';
import { isValidPhone, isValidEmail } from '../utils/validation';

export default function Step07_Contact({ onNext, onBack }) {
  const { state, dispatch } = useForm();
  const [errs, setErrs] = useState({});
  const c = state.contact;

  const set = (field, val) => {
    dispatch({ type: 'SET_NESTED', key: 'contact', value: { [field]: val } });
    setErrs(e => ({ ...e, [field]: '' }));
  };

  const next = () => {
    const e = {};
    if (!c.homePhone && !c.cellPhone) e.phone = 'At least one phone number is required';
    if (c.homePhone && !isValidPhone(c.homePhone)) e.homePhone = 'Enter a valid phone number';
    if (c.cellPhone && !isValidPhone(c.cellPhone)) e.cellPhone = 'Enter a valid phone number';
    if (c.email && !isValidEmail(c.email)) e.email = 'Enter a valid email address';
    if (Object.keys(e).length) { setErrs(e); return; }
    onNext();
  };

  return (
    <div className="step-card">
      <h2 className="step-title">Contact Information</h2>
      <p className="step-subtitle">At least one phone number is required. Email is optional.</p>
      <div className="field-group">
        <label className="field-label">Home Phone</label>
        <input className={`field-input ${errs.homePhone ? 'error' : ''}`} value={c.homePhone}
          onChange={e => set('homePhone', e.target.value)} placeholder="(606) 555-1234" type="tel" />
        {errs.homePhone && <div className="field-error">{errs.homePhone}</div>}
      </div>
      <div className="field-group">
        <label className="field-label">Cell Phone</label>
        <input className={`field-input ${errs.cellPhone ? 'error' : ''}`} value={c.cellPhone}
          onChange={e => set('cellPhone', e.target.value)} placeholder="(606) 555-5678" type="tel" />
        {errs.cellPhone && <div className="field-error">{errs.cellPhone}</div>}
      </div>
      {errs.phone && <div className="field-error" style={{ marginTop: -8, marginBottom: 8 }}>{errs.phone}</div>}
      <div className="field-group">
        <label className="field-label">Email Address <span className="field-hint">(optional)</span></label>
        <input className={`field-input ${errs.email ? 'error' : ''}`} value={c.email}
          onChange={e => set('email', e.target.value)} placeholder="driver@email.com" type="email" />
        {errs.email && <div className="field-error">{errs.email}</div>}
      </div>
      <div className="wizard-nav" style={{ position: 'static', borderTop: 'none', padding: 0, marginTop: 24 }}>
        <button className="btn-back" onClick={onBack}>← Back</button>
        <button className="btn-next" onClick={next}>Next →</button>
      </div>
    </div>
  );
}
